<div class="stepper-header"
     [ngStyle]="{'--progress': (currentStep + 1) / steps.length}">
  <ng-container *ngFor="let step of steps.toArray(); let i = index">
    <div class="step-item"
         [class.active]="i <= currentStep"
         (click)="goToStep(i)"
         [ngClass]="{ 'disabled': !formValid }">
      <div class="step-label">{{ titles[i] || 'Step' }}</div>
      <div class="step-circle">{{ i + 1 }}</div>
    </div>
  </ng-container>
</div>

<div [@slideAnimation]="animationState" class="step-body">
  <ng-container *ngTemplateOutlet="currentTemplate"></ng-container>
</div>
